import React from "react";
// import ReactButton, { SecondaryButton as ReactSecondaryButton } from "@vzrf/react-button";
import {Button}  from "@vds/buttons";
import styled, { css } from "styled-components";
import { media } from "utils/style";

const Buttons = props =>
  props.background === "white_background" ? (
    <SecondaryButton   size ="large" use="secondary" {...props}>{props.children}</SecondaryButton>
  ) : (
    <StandardButton size="large" {...props}>{props.children}</StandardButton>
  );

export default Buttons;

const sharedStyle = css`
  max-width: 424px;
  margin: 0 12px 0 0;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter: 0.5px;

  ${media.mobile`
    width: 100% !important;
    margin-bottom: 5px !important;
    font-size: 16px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    line-height: 20px;
    letter: 0.5px;
  `};
`;

const SecondaryButton = styled(Button)`
  ${sharedStyle}
`;

const StandardButton = styled(Button)`
  ${sharedStyle}
`;
